// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/common/QuoteBlock/QuoteBlock.css
// module id = 884
// module chunks = 0